var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftNav2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45227_190830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2225 6.00917C10.2183 5.90326 10.1748 5.78083 10.1021 5.70362L7.43549 2.88883C7.27978 2.70434 6.98024 2.70804 6.80519 2.87428C6.63014 3.04052 6.61577 3.33491 6.79201 3.49993L8.74569 5.56473H2.66704C2.42159 5.56473 2.2226 5.76372 2.2226 6.00917C2.2226 6.25464 2.42159 6.45361 2.66704 6.45361H8.74569L6.79201 8.51841C6.6158 8.68345 6.63023 8.97909 6.80534 9.14532C6.98039 9.31156 7.28418 9.31229 7.43557 9.12952L10.1022 6.31473C10.1833 6.22853 10.2213 6.128 10.2225 6.00917Z",
    fill: "#002466"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45227_190830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(2.22266 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftNav2);
export default __webpack_public_path__ + "static/media/arrow-left-nav 2.85477ab801255abf2442f5185546ad22.svg";
export { ForwardRef as ReactComponent };